import { theme } from "../../theme/theme";
import { V3IconInfo } from "../Icons";
import { V3CaptionGrey35 } from "../ReusableStyledComponents/V3CaptionGrey35";
import { VerticalSpacing } from "../VerticalSpacing";
import { CBDWrapper } from "./BannerDetails.styles";

interface BannerDetailsProps extends React.PropsWithChildren {
    useYellow?: boolean;
    customPadding?: string;
    allowUserThemable?: boolean;
}

export const BannerDetails = ({ children, customPadding, useYellow = false, allowUserThemable = false }: BannerDetailsProps) => {
    return (
        <VerticalSpacing bottom={12} top={12}>
            <CBDWrapper $useYellow={useYellow} $customPadding={customPadding} $allowUserThemable={allowUserThemable}>
                <div>
                    <V3IconInfo stroke={useYellow ? theme.v3.colors.yellow : theme.v3.colors.midBlue} />
                </div>
                <div>
                    <V3CaptionGrey35>{children}</V3CaptionGrey35>
                </div>
            </CBDWrapper>
        </VerticalSpacing>
    );
};
